module.exports = __webpack_public_path__ + "media/images/branch-location-a9b1bdbf450dc33a41e811547824e491.png";